import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import { reactive, watch, ref } from 'vue';
import useDecryptSymbols from './useDecryptSymbols';

const { decryptSymbols } = useDecryptSymbols();

const contacts = reactive([]);

const refetchContacts = ref(null);

const GET_CONTACTS = gql`
  query ContactsQuery {
    contacts {
      FIRSTNAME
      LASTNAME
      CONTACTID
    }
  }
`;

const useContactsQuery = function () {
  const { result, loading, error, refetch } = useQuery(GET_CONTACTS);
  refetchContacts.value = refetch;
  watch(result, () => {
    const decrypted = decryptSymbols(result.value.contacts);
    contacts.splice(0, contacts.length, ...decrypted);
  });
};

export default {
  useContactsQuery,
  contacts,
  refetchContacts,
};
